export const SLIDER = {
  ARROW_DIRECTION: {
    prev: 'prev',
    next: 'next'
  },

  CONTAINER_HEIGHT:
  {
    large: 104,
    mobileLarge: 96,
    small: 80
  },
  THEMES: {
    none: 'none',
    diagonal: 'diagonal'
  }
}
